module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.75d3d3ee.jpg";